import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  id: "show-privileges",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = { key: 1 }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_7 = { class: "col margin-left-3" }
const _hoisted_8 = { class: "col d-flex flex-row align-items-center justify-content-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  id: "action-loading",
  class: "spinner-border spinner-border-sm"
}
const _hoisted_12 = { class: "loader-div-40" }
const _hoisted_13 = ["src"]

import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElTable,
  ElTableColumn,
} from "element-plus";
import { onMounted, ref } from "vue";
import { cloneDeep } from "lodash-es";
import { TYPE } from "vue-toastification";
import { router } from "@/core/router";
import { hasPermission } from "@/core/auth";
import {
  deletePrivilege,
  editPrivilege,
  getPrivilegeList,
} from "@/privilege/services/privilege.service";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";


export default /*#__PURE__*/_defineComponent({
  __name: 'Privileges',
  setup(__props) {

const { t } = i18n.global;

const loadingPrivileges = ref(false);

const search = ref("");
const animate = ref(false);

const editMode = ref(false);

const privileges = ref([]);

const hoverId = ref("");

function cellMouseEnter(row) {
  hoverId.value = row.id;
}

function cellMouseLeave() {
  hoverId.value = "";
}

const newObject = ref({
  id: undefined,
  name: undefined,
  privilegeId: undefined,
  description: undefined,
});

const headerStyle = ref({
  color: "black",
  borderBottomColor: "#808080FF",
});

const rowStyle = ref({
  cursor: "pointer",
});

function openEditMode(row) {
  animate.value = false;
  if (
    newObject.value.id !== row.id &&
    hasPermission("PRIVILEGES.LIST.INLINE.EDIT")
  ) {
    newObject.value = cloneDeep(row);
    editMode.value = true;
  }
}

function closeEditMode() {
  editMode.value = false;
  newObject.value = {
    name: undefined,
    id: undefined,
    description: undefined,
    privilegeId: undefined,
  };
}

function goToEditPage(row) {
  if (hasPermission("PRIVILEGES.LIST.EDIT") && newObject.value.id !== row.id) {
    router.push(`/privileges/edit/${row.id}`);
  } else if (newObject.value.id === row.id) {
    animate.value = true;
    setTimeout(() => {
      animate.value = false;
    }, 2200);
  }
}

async function getPrivileges() {
  loadingPrivileges.value = true;
  await getPrivilegeList().then((response) => {
    if (response) {
      privileges.value = response;
    }
  });
  loadingPrivileges.value = false;
}

async function inLineEditPrivilege(privilege) {
  let result = false;
  await editPrivilege(privilege).then(async (response) => {
    if (response) {
      result = true;
    }
  });
  return result;
}

async function editSelectedPrivilege() {
  if (
    editMode.value &&
    newObject.value.name &&
    hasPermission("PRIVILEGES.LIST.INLINE.EDIT")
  ) {
    const result = await inLineEditPrivilege(newObject.value);
    if (result) {
      editMode.value = false;
      newObject.value = {
        name: undefined,
        id: undefined,
        description: undefined,
        privilegeId: undefined,
      };
    }
    await getPrivileges();
    showAlert(TYPE.SUCCESS, t("Privilege.PrivilegeSaved"));
  } else if (hasPermission("PRIVILEGES.LIST.INLINE.EDIT")) {
    showAlert(TYPE.WARNING, t("Common.WarningMsg"));
  }
}

async function deleteSelectedPrivilege(privilege) {
  if (hasPermission("PRIVILEGES.LIST.REMOVE")) {
    const isConfirmed = await showConfirm(
      "warning",
      t("Privilege.DeletePrivilege"),
      t("Privilege.DeleteQuestion")
    );
    if (isConfirmed) {
      privilege.loading = true;
      const result = await deletePrivilege(privilege.id);
      privilege.loading = false;
      if (result) {
        await getPrivileges();
      } else {
        showAlert(TYPE.ERROR, t("Privilege.DeleteFailed"));
      }
    }
  }
}

onMounted(() => {
  getPrivileges();
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ElCard), {
      class: "card",
      "body-style": { height: '100%' }
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(ElTable), {
          data: 
          search.value
            ? privileges.value.filter((data) =>
                data.name.toLowerCase().includes(search.value.toLowerCase())
              )
            : privileges.value
        ,
          "empty-text": loadingPrivileges.value ? ' ' : 'No Data',
          "header-cell-style": headerStyle.value,
          onRowClick: goToEditPage,
          onCellMouseEnter: cellMouseEnter,
          onCellMouseLeave: cellMouseLeave,
          "row-style": 
          _unref(hasPermission)('PRIVILEGES.LIST.EDIT') ? rowStyle.value : undefined
        ,
          height: "100%"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Name'),
              prop: "name",
              sortable: "",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      placeholder: _unref(t)('Common.Name'),
                      onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
                      modelValue: newObject.value.name,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((newObject.value.name) = $event))
                    }, null, 8, ["placeholder", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("strong", null, _toDisplayString(scope.row.name), 1),
                      (
                  _unref(hasPermission)('PRIVILEGES.LIST.INLINE.EDIT') &&
                  scope.row.id === hoverId.value
                )
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "pencil-span",
                            onClick: _withModifiers(($event: any) => (openEditMode(scope.row)), ["stop"])
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "pencil-alt" })
                          ], 8, _hoisted_3))
                        : _createCommentVNode("", true)
                    ]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              label: "ID",
              prop: "privilegeId",
              sortable: "",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      placeholder: _unref(t)('Common.Name'),
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"])),
                      modelValue: newObject.value.privilegeId,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((newObject.value.privilegeId) = $event))
                    }, null, 8, ["placeholder", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createElementVNode("strong", null, _toDisplayString(scope.row.privilegeId), 1)
                    ]))
              ]),
              _: 1
            }),
            _createVNode(_unref(ElTableColumn), {
              label: _unref(t)('Common.Description'),
              prop: "description",
              width: "auto"
            }, {
              default: _withCtx((scope) => [
                (editMode.value && scope.row.id === newObject.value.id)
                  ? (_openBlock(), _createBlock(_unref(ElInput), {
                      key: 0,
                      placeholder: _unref(t)('Common.Description'),
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                      modelValue: newObject.value.description,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((newObject.value.description) = $event))
                    }, null, 8, ["placeholder", "modelValue"]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                      _createElementVNode("strong", null, _toDisplayString(scope.row.description), 1)
                    ]))
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_unref(ElTableColumn), {
              prop: "actions",
              width: "300px"
            }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_6, [
                  _createVNode(_unref(ElInput), {
                    modelValue: search.value,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((search).value = $event)),
                    size: "mini",
                    style: {"max-width":"170px"},
                    placeholder: _unref(t)('Common.TypeToSearch')
                  }, null, 8, ["modelValue", "placeholder"]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_unref(ElButton), {
                      class: "no-border btn-oneTeg2",
                      size: "mini",
                      type: "primary",
                      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_unref(router).push('/privileges/create')), ["stop"]))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "plus" })
                      ]),
                      _: 1
                    }),
                    _createVNode(_unref(ElButton), {
                      loading: loadingPrivileges.value,
                      onClick: _withModifiers(getPrivileges, ["stop"]),
                      class: "no-border btn-oneTeg margin-left-3",
                      size: "mini",
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ])
                ])
              ]),
              default: _withCtx((scope) => [
                _createElementVNode("div", _hoisted_8, [
                  (
                  editMode.value &&
                  scope.row.id === newObject.value.id &&
                  _unref(hasPermission)('PRIVILEGES.LIST.INLINE.EDIT')
                )
                    ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                        _createElementVNode("div", {
                          class: _normalizeClass({ animateBtn: animate.value })
                        }, [
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg",
                            style: {"max-width":"42.5px"},
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(editSelectedPrivilege, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "check" })
                            ]),
                            _: 1
                          }),
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg margin-left-3",
                            "native-type": "submit",
                            size: "mini",
                            type: "primary",
                            onClick: _withModifiers(closeEditMode, ["stop"])
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_font_awesome_icon, { icon: "times" })
                            ]),
                            _: 1
                          })
                        ], 2)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_unref(ElDropdown), null, {
                          dropdown: _withCtx(() => [
                            _createVNode(_unref(ElDropdownMenu), null, {
                              default: _withCtx(() => [
                                (_unref(hasPermission)('PRIVILEGES.LIST.EDIT'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 0,
                                      onClick: _withModifiers(($event: any) => (
                          _unref(router).push('/privileges/edit/' + scope.row.id)
                        ), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Edit")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (_unref(hasPermission)('PRIVILEGES.LIST.REMOVE'))
                                  ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                      key: 1,
                                      onClick: _withModifiers(($event: any) => (deleteSelectedPrivilege(scope.row)), ["stop"])
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_unref(t)("Common.Delete")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_unref(ElButton), {
                              class: "no-border btn-oneTeg show-on-row-hover",
                              size: "mini",
                              onClick: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["stop"])),
                              type: "primary"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_font_awesome_icon, { icon: "cog" })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ]))
                ]),
                _withDirectives(_createElementVNode("span", _hoisted_11, null, 512), [
                  [_vShow, scope.row.loading]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["data", "empty-text", "header-cell-style", "row-style"])
      ]),
      _: 1
    }),
    _withDirectives(_createElementVNode("div", _hoisted_12, [
      _createElementVNode("img", {
        src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
        alt: "Loading...",
        class: "loader-logo-40"
      }, null, 8, _hoisted_13)
    ], 512), [
      [_vShow, loadingPrivileges.value]
    ])
  ]))
}
}

})